import type { FC } from 'react';

import { useContent } from '@eneco/cms';
import { Box, NavLink, PageGrid, Stack } from '@eneco/sparky';

import type { RegistrationFooterContent } from './registration-footer-content.types';

/**
 * `RegistrationFooter` block for the CMS-agnostic lane, serving **both** providers.
 *
 * Mirrors the legacy component (`apps/accessmanagement/nl/multilabel/src/components/RegistrationFooter/
 * RegistrationFooter.tsx`): a right-aligned privacy statement link on the primary background. It has
 * no settings and no nested placeholders.
 */
const RegistrationFooter: FC = () => {
  const content = useContent<RegistrationFooterContent>();

  return (
    <Box backgroundColor="backgroundPrimary" paddingY="3">
      <PageGrid>
        <PageGrid.Item gridColumn="1/-1">
          <Stack direction="row" alignX="end">
            {content.privacyStatementLink?.href && (
              <NavLink href={content.privacyStatementLink.href} variant="secondary">
                {content.privacyStatementLink.text}
              </NavLink>
            )}
          </Stack>
        </PageGrid.Item>
      </PageGrid>
    </Box>
  );
};

export default RegistrationFooter;
